/* global jQuery Swiper initMap tgInit */
const ajaxurl = tca_local.ajax_url;

; (function ($) {
	$(document).ready(function () {
		// runs for first page load
		init()
	})

	function init() {
		/**
		 * Run initialition for core functionality
		 */
		coreInit()

		/**
		 * run initialisation for external scripts
		 */
		animationInit()
		//initMap()
		gridSlider()
	}

	function coreInit() {
		// helps us detect touchscreen-based browsers
		window.isTouch = false
		$(window).one('touchstart', function onFirstTouch() {
			window.isTouch = true
			$('body').addClass('is-touch')
		})

		setScrollbar()

		/**
		 * General/global
		 */
		$('[input-select-all]').on('focus click', function () {
			setTimeout(() => {
				this.focus()
				this.setSelectionRange(0, 99999)
				this.select()
			}, 50)
		})

		/**
		 * navigation
		 */
		// mobile nav toggle
		$('#nav-toggle').click(function () {
			$('#site-navigation').toggleClass('toggled')
			$('#nav-toggle').toggleClass('toggled')
			$('body').toggleClass('is-no-scroll')
			$('#primary-menu .menu-item-has-children>a').removeClass('active').next().slideUp(200)
			$(this).attr(
				'aria-expanded',
				$(this).attr('aria-expanded') === 'false'
			)
		})
		// if mobile nav or if touchscreen, menu items with children can not be followed
		$('#primary-menu .menu-item-has-children>a').click(function (e) {
			if ($(window).width() < 996 || window.isTouch) {
				e.preventDefault()
				e.stopPropagation()
			}
		})
		// mobile menu sub-menu handling
		$('#site-menu .has-submenu>a').click(function (e) {
			if ($('#site-navigation').hasClass('toggled')) {

				e.preventDefault()
				let dir = $(this).parent().attr('aria-expanded') === 'true'
				if (dir) {
					$(this).next().slideUp(200)
					$(this).parent().attr('aria-expanded', 'false')
					$(this).parent().removeClass('expanded')
				} else {
					$(this).next().slideDown(200)
					$(this).parent().attr('aria-expanded', 'true')
					$(this).parent().addClass('expanded')
				}
			}
		})
		// when mobile menu open a click to anything else closes it
		$(document).click(function (event) {
			if (!$(event.target).closest('#site-navigation .site-mask, #nav-toggle').length && $('#site-navigation').hasClass('toggled')) {
				$('#site-navigation').removeClass('toggled')
				$('#nav-toggle').removeClass('toggled')
				$('body').removeClass('is-no-scroll')
			}
		})
		// mobile home nav background
		if ($('body').hasClass('home')) {
			navBg()
			$(document).on('scroll.headerbg', throttle(function () {
				navBg()
			}, 50))
			$(document).on('resize.headerbg', throttle(function () {
				navBg()
			}, 50))
		}

		function navBg() {
			if ($(window).width() < 996) {
				let opacity = $(window).scrollTop() / 400
				$('#header .header-bg').css('opacity', opacity > 0.85 ? 0.85 : opacity)
			} else {
				$('#header .header-bg').css('opacity', '')
			}
		}

		// on scroll
		$(window).scroll(function () {
			scrolling(this)
		});

		// on resize
		$(window).on('resize', function () {
			scrolling(this)
			$('body').removeClass('js-menu-mobile-active')
		});

		// scrolling function
		let stickyPoint = 300;

		function scrolling(el) {
			let scroll = $(el).scrollTop()
			// if header out of view, prep it off canvas for being sticky
			if (scroll > stickyPoint) {
				$('#header').addClass('js-sticky')
			} else {
				$('#header').removeClass('js-sticky')
			}

			// when past sticky point, bring in header
			if (scroll > stickyPoint && !$('#header').hasClass('js-on')) {
				$('#header').addClass('js-on')
			} else if (scroll < stickyPoint && $('#header').hasClass('js-on')) {
				$('#header').removeClass('js-on')
			}

		}

		/**
		 * page head — carousel
		 */
		if ($('.v-pageHead__slide', '.v-pageHead__slider').length > 1) {
			new Swiper('.v-pageHead__slider', {
				autoplay: {
					delay: 7000
				},
				loop: true,
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					bulletElement: 'button',
					clickable: true
				}
			})
		}

		/**
		 * testimonials
		 */
		new Swiper('.v-testimonials .swiper-container', {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 10,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			autoplay: {
				delay: 5000,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			},
		})

		/**
		 * gallery section
		 */
		let galleryInit = false
		gallerySlider()
		function gallerySlider() {
			if (window.innerWidth < 992 && !galleryInit) {
				new Swiper('.v-gallery .swiper-container', {
					slidesPerView: 1,
					breakpoints: {
						768: {
							slidesPerView: 2
						}
					}
				})
				galleryInit = true
			} else if (window.innerWidth >= 992 && galleryInit) {
				$('.v-gallery .swiper-container').each(function () {
					$(this)[0].swiper.destroy()
				})
				galleryInit = false
			}
		}
		$(window).on('resize.gallerySlider', throttle(function () {
			gallerySlider()
		}, 50))

		/**
		 * logo slider
		 */
		new Swiper('.v-logos--slider--normal .v-logos__slider', {
			loop: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			breakpoints: {
				540: {
					slidesPerView: 2
				},
				768: {
					slidesPerView: 3
				},
				996: {
					slidesPerView: 5
				}
			}
		})
		new Swiper('.v-logos--slider--large .v-logos__slider', {
			slidesPerView: 1,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				992: {
					slidesPerView: 3
				}
			}
		})

		/**
		 * news slider
		 */
		new Swiper('.v-news__slider', {
			autoplay: {
				delay: 4000
			},
			loop: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				1199: {
					slidesPerView: 3
				},
				1399: {
					slidesPerView: 4
				}
			}
		})

		/**
		 * advanced content image slider
		 */
		new Swiper('.v-content__advanced-item--image_slider', {
			slidesPerView: 1,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				996: {
					slidesPerView: 3
				}
			}
		})

		/**
		 * switch modal
		 */
		$('.switch-modal').click(function () {
			var modal_close = $(this).closest('.modal');
			var modal_open = $(this).data('target');
			$(modal_close).modal('hide');
			$(modal_close).one('hidden.bs.modal', function () {
				$(modal_open).modal('show');
			});
		});
		/**
		 * skip link
		 */
		$('.skip-link').click(function (event) {
			event.preventDefault();
			var skipto = $(this).data('skipto');
			if (skipto) {
				var skipPage = $('html, body');

				skipPage.on('mousedown wheel DOMMouseScroll mousewheel touchmove', function () {
					skipPage.stop();
				});

				skipPage.animate({
					scrollTop: $(skipto).offset().top - $('#header').height()
				}, 1000, function () {
					skipPage.off('mousedown wheel DOMMouseScroll mousewheel touchmove')
				})
			}
		});

		$('.back-to-top').click(function (event) {
			event.preventDefault();
			var skipto = $(this).data('skipto');
			if (skipto) {
				var skipPage = $('html, body');

				skipPage.on('mousedown wheel DOMMouseScroll mousewheel touchmove', function () {
					skipPage.stop();
				});

				skipPage.animate({
					scrollTop: $(skipto).offset().top - $('#header').height()
				}, 1000, function () {
					skipPage.off('mousedown wheel DOMMouseScroll mousewheel touchmove')
				})
			}
		});



		/**
		 * location section
		 */
		// location section hover
		$('.v-locations__mapMarker').hover(function () {
			$('.v-locations__list').addClass('map-hover')
			$('.v-locations__list li').eq($(this).index() - 1).addClass('is-hover')
		}, function () {
			$('.v-locations__list').removeClass('map-hover')
			$('.v-locations__list li').removeClass('is-hover')
		})
		$('.v-locations__list-button').hover(function () {
			$('.v-locations__map').addClass('list-hover')
			$('.v-locations__mapMarker').eq($(this).parent().index()).addClass('is-hover')
		}, function () {
			$('.v-locations__map').removeClass('list-hover')
			$('.v-locations__mapMarker').removeClass('is-hover')
		})
		// toggle address panel
		$('.v-locations__list-button, .v-locations__mapMarker').click(function () {
			const i = $(this).hasClass('v-locations__list-button') ? $(this).parent().index() : $(this).index() - 1
			const $addressPanel = $('.v-locations__address')
			const $addresses = $('.v-locations__addressItem')
			const $locationList = $('.v-locations__list')
			const $locations = $('.v-locations__list li')
			const wasVisible = $addresses.eq(i).hasClass('is-visible')

			$locationList.removeClass('address-active')
			$addressPanel.removeClass('is-active')
			$locations.removeClass('is-active').removeClass('is-hover')
			$addresses.removeClass('is-visible')
			if (!wasVisible) {
				$locationList.addClass('address-active')
				$addressPanel.addClass('is-active')
				$locations.eq(i).addClass('is-active')
				$addresses.eq(i).addClass('is-visible')
			}
		})
		// close address panel
		$('.v-locations__addressClose').click(function () {
			$('.v-locations__list').removeClass('address-active')
			$('.v-locations__list li').removeClass('is-active')
			$('.v-locations__address').removeClass('is-active')
			$('.v-locations__addressItem').removeClass('is-visible')
		})

		/**
		 * advanced focus handling
		 */
		$('.v-panels__button').click(function () {
			$(this).next().focus()
		})

		/**
		 * social sharing
		 */
		$('.v-share__btn--general').click(function () {
			if (navigator.share) {
				navigator.share({
					url: $(this).data('url'),
					title: $(this).data('title'),
					text: $(this).data('text')
				})
			} else {
				$.fancybox.open({
					src: '#social-share-modal'
				})
			}
		})

		$('.v-share-modal__copy-button').click(function () {
			let link = $(this).prev()[0]
			let currentFocus = document.activeElement
			link.focus()
			link.setSelectionRange(0, link.value.length)
			let success
			try {
				success = document.execCommand('copy')
			} catch (e) {
				success = false
			}
			if (currentFocus && typeof currentFocus.focus === 'function') {
				currentFocus.focus()
			}

			if (success) {
				let parent = $(this).parent()
				parent.removeClass('is-copied')
				void parent[0].offsetWidth
				parent.addClass('is-copied')
			}
		})


		/**
		 * footer
		 */
		// mobile footer 'accordion' on mobile
		$('.footer-accordion-button').click(function () {
			if ($(window).width() < 996) {
				$(this)
					.closest('.accordion')
					.toggleClass('shown')
			}
		})
	}

	function gridSlider() {
		if ($('.v-gridSlider').length) {
			let rows = 2
			if ($(window).width() < 768) {
				rows = 1
			}
			$('.v-gridSlider .tg-layout-grid').data('row', rows)
			tgInit()

			const rightArrow = $('.v-gridSlider__arrow.tg-right-arrow')
			rightArrow.before(rightArrow.next())

			const MutationObserver = window.MutationObserver || window.WebKitMutationObserver
			const observer = new MutationObserver(throttle(gridSliderMutation, 300))
			const obsConfig = {
				attributeFilter: ['style'],
				attributes: true,
				characterData: false,
				subtree: false
			}

			$('.v-gridSlider .tg-layout-grid').each(function () {
				observer.observe(this, obsConfig)
			})
		}
	}

	function gridSliderMutation(mutationRecords) {
		$.each(mutationRecords, function (i, mutation) {
			const $gridSlider = $(mutation.target)
			const width = $gridSlider.parent().outerWidth()

			const transform = $gridSlider.css('transform')
			let matrixIndex
			if (transform.substring(0, 8) === 'matrix3d') {
				matrixIndex = 13
			} else {
				matrixIndex = 4
			}
			const transformX = parseFloat(transform.match(/-?[\d.]+/g)[matrixIndex])

			$gridSlider.children().each(function () {
				const left = parseFloat($(this).css('left'))
				const center = left + ($(this).outerWidth() / 2)
				const offset = center + transformX

				if (offset > -10 && offset < width + 10) {
					$(this).addClass('tg-item-active')
				} else {
					$(this).removeClass('tg-item-active')
				}
			})
		})
	}

	function animateOut() {
		// hide nav
		$('#site-navigation').removeClass('toggled')
		$('#nav-toggle').removeClass('toggled')
	}

	function unload() {
		// close any open fancybox instances
		$.fancybox.close()

		// header bg fade in
		$(document).off('scroll.headerbg')
		$(document).off('resize.headerbg')

		// footer
		$('.footer-accordion-button').off('click')
	}

	// set scrollbar
	function setScrollbar() {
		var body = document.querySelector('body')
		if (window.innerWidth > body.clientWidth + 5) {
			$('body').removeClass('no-scrollbar')
			document.documentElement.style.setProperty(
				'--scrollbar-width',
				window.innerWidth - body.clientWidth + 'px'
			)
		} else {
			$('body').addClass('no-scrollbar')
		}
	}

	// Returns a function, that, when invoked, will only be triggered at most once
	// during a given window of time. Normally, the throttled function will run
	// as much as it can, without ever going more than once per `wait` duration;
	// but if you'd like to disable the execution on the leading edge, pass
	// `{leading: false}`. To disable execution on the trailing edge, ditto.
	function throttle(func, wait, options) {
		var context, args, result
		var timeout = null
		var previous = 0
		if (!options) options = {}
		var later = function () {
			previous = options.leading === false ? 0 : Date.now()
			timeout = null
			result = func.apply(context, args)
			if (!timeout) context = args = null
		}
		return function () {
			var now = Date.now()
			if (!previous && options.leading === false) previous = now
			var remaining = wait - (now - previous)
			context = this
			args = arguments
			if (remaining <= 0 || remaining > wait) {
				if (timeout) {
					clearTimeout(timeout)
					timeout = null
				}
				previous = now
				result = func.apply(context, args)
				if (!timeout) context = args = null
			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining)
			}
			return result
		}
	}

	/** Scroll */
	$(window).scroll(function () {
		scrolling(this)
	});


	let quotePoint = 600
	function scrolling(el) {
		let scroll = $(el).scrollTop()

		// quote button
		if (scroll >= quotePoint && !$('#quote-button').hasClass('js-show')) {
			$('#quote-button').addClass('js-show')
		} else if (scroll < quotePoint && $('#quote-button').hasClass('js-show')) {
			$('#quote-button').removeClass('js-show')
		}

		if (scroll >= (quotePoint + quotePoint + quotePoint) && !$('#back-to-top').hasClass('js-show')) {
			$('#back-to-top').addClass('js-show')
		} else if (scroll < quotePoint && $('#back-to-top').hasClass('js-show')) {
			$('#back-to-top').removeClass('js-show')
		}


	}


	$('.toggle-audio').on('click', function () {
		var video = $(this).data('video');

		if ($(this).hasClass('audio-on')) {
			$(this).removeClass('audio-on');
			$(video).prop('muted', true);
		} else {
			$(this).addClass('audio-on');
			$(video).prop('muted', null);
		}
	});


	const default_video_pause_string = '<i class="far fa-play-circle" aria-hidden="true"></i> Watch video';
	const default_video_playing_string = '<i class="far fa-play-circle" aria-hidden="true"></i> Watching ... ';

	$(document).on('click', '.video-expand .fa-expand', function playInFullScreen() {
		let elemId = $(this).attr('id');
		let targetVideoId = elemId.slice(-1);
		let elemVideo = $('#menu_video' + targetVideoId).get(0);

		if (elemVideo.requestFullscreen) {
			elemVideo.requestFullscreen();
		} else if (elemVideo.mozRequestFullScreen) {
			elemVideo.mozRequestFullScreen();
		} else if (elemVideo.webkitRequestFullscreen) {
			elemVideo.webkitRequestFullscreen();
		} else if (elemVideo.msRequestFullscreen) {
			elemVideo.msRequestFullscreen();
		}
	})

	function playPause(videoSelector, btnClass, expandId, watchid) {
		if (videoSelector.paused) {
			videoSelector.play();
			$(btnClass).addClass('playing');
			$(btnClass).removeClass('paused');
			$(expandId).addClass('playing');
			$(expandId).removeClass('paused');
			$(watchid).addClass('playing').html(default_video_playing_string);
			$(watchid).removeClass('paused');

		} else {
			videoSelector.pause();
			$(btnClass).addClass('paused');
			$(btnClass).removeClass('playing');
			$(expandId).addClass('paused');
			$(expandId).removeClass('playing');
			$(watchid).addClass('paused').html(default_video_pause_string);
			$(watchid).removeClass('playing');
		}
	}

	var menuVideo = $('#menu_video0').get(0);

	$('.video-wrapper').on('click', function () {
		let targetVideoId = $(this).find('.menu-video').attr('id');
		menuVideo = $('#' + targetVideoId).get(0);
		var targetid = $(this).find('.fa-play-circle').attr('id');
		var expandTargetid = $(this).find('.fa-expand').attr('id');
		var watching_string_id = $(this).parent('.item-wrapper-why-us').find('.play-menu-video-link').attr('id');
		console.log(watching_string_id);
		playPause(menuVideo, '#' + targetid, '#' + expandTargetid, '#' + watching_string_id);
	});


	$('.play-menu-video-link').on('click', function () {
		$(this).parent('.item-wrapper').find('.video-wrapper').click();
	})

	new Swiper('.menuReviewsSwiper', {
		slidesPerView: 1,
		spaceBetween: 20,
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	})


	var swiper = new Swiper(".mapSwiper", {
		slidesPerView: 1,
		spaceBetween: 15,
		allowTouchMove: false,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				return '<span class="' + className + '">' + ((index == 0) ? 'MAP' : 'LIST') + "</span>";
			},
		},
	});



	var accreditation = new Swiper('.accreditationSwiper', {
		slidesPerView: 1,
		spaceBetween: 50,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false,
		},
		loop: true,
		breakpoints: {
			380: {
				slidesPerView: 2
			},
			580: {
				slidesPerView: 3
			},
			768: {
				slidesPerView: 4
			},
			996: {
				slidesPerView: 5
			},
			1200: {
				slidesPerView: 6
			}
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},
	})

	var postVideo = new Swiper('.post-box-swiper', {
		slidesPerView: 1,
		spaceBetween: 30,
		autoplay: {
			delay: 10000,
			disableOnInteraction: false,
		},
		//loop: true,
		breakpoints: {
			768: {
				slidesPerView: 2
			},
			996: {
				slidesPerView: 3
			}
		},
		navigation: {
			nextEl: '.post-swiper-button-next',
			prevEl: '.post-swiper-button-prev'
		},
	})


	var imgSlider = new Swiper('.section-image-swiper', {
		slidesPerView: 1,
		spaceBetween: 20,
		loop: true,
		autoplay: {
			delay: 2000,
		},
		// grabCursor: true,
		// effect: "creative",
		// creativeEffect: {
		// 	prev: {
		// 		shadow: true,
		// 		translate: ["-20%", 0, -1],
		// 	},
		// 	next: {
		// 		translate: ["100%", 0, 0],
		// 	},
		// },
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},
	})


	$('#accordion').on('click', 'h5', function () {
		$(this).removeClass('custom-class');
	});


	// Form
	var service_location_request_for_this_page = false;
	var service = '';
	var location = '';

	function updateFormFields(field_id, val) {
		$('#' + field_id).val(val);
	}

	function hideServiceField() {
		$('#field_2_16').slideUp();

	}

	function updateForm() {
		if (service || location) {
			updateFormFields('input_2_18', service);
			hideServiceField()
			updateFormFields('input_2_8', location);
			service_location_request_for_this_page = true;

			return;
		}

		let postData = {
			"action": "tca_service",
			"post_action": "get_service_location_from_url",
			"filters": { 'url': window.location.href }
		}

		let request = $.post(ajaxurl, postData);
		request.done(function (response) {
			const result = JSON.parse(response);
			if (result.success) {
				if (result.data.service) {
					service = result.data.service;
					updateFormFields('input_2_18', result.data.service);
					hideServiceField()
				}

				if (result.data.location) {
					location = result.data.location;
					updateFormFields('input_2_8', result.data.location);
				}
				service_location_request_for_this_page = true;
			}
		})
	}

	// $('.action-btn a').click(function (e) {
	// 	e.preventDefault();
	// 	$('#survey-form').modal().show();
	// })

	//before show the form
	$('#survey-form').on('show.bs.modal', function (event) {
		var button = $(event.relatedTarget) // Button that triggered the modal
		service = button.data('service')
		location = button.data('location')
	})

	//after show the form
	$('#survey-form').on('shown.bs.modal', function (event) {
		if (!service_location_request_for_this_page) {
			updateForm(); // update form with service and location
		}
	})



})(jQuery);
